var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "on-clickaway",
          rawName: "v-on-clickaway",
          value: _vm.hideLayoutMenu,
          expression: "hideLayoutMenu"
        }
      ],
      staticClass: "layout-selection-container"
    },
    [
      _c(
        "v-tooltip",
        {
          attrs: { bottom: "", color: "primary", "open-delay": "100" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function(ref) {
                var on = ref.on
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      {
                        staticClass: "ma-0",
                        attrs: {
                          text: "",
                          icon: "",
                          height: "38",
                          width: "28"
                        },
                        on: {
                          click: function($event) {
                            _vm.layoutMenuOpen = !_vm.layoutMenuOpen
                          }
                        }
                      },
                      on
                    ),
                    [
                      _c("v-icon", { attrs: { color: "#767676" } }, [
                        _vm._v("view_compact")
                      ])
                    ],
                    1
                  )
                ]
              }
            }
          ])
        },
        [
          _vm._v(" "),
          _c("span", { staticStyle: { "font-size": "9px" } }, [
            _vm._v(_vm._s(_vm.$t("SplitScreen")))
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.layoutMenuOpen,
              expression: "layoutMenuOpen"
            }
          ]
        },
        [
          _c(
            "div",
            { staticClass: "layout-selection-menu" },
            [
              _c("LayoutOneSVG", {
                staticClass: "layout-icon layout-1",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.setActiveLayout(1)
                  }
                }
              }),
              _vm._v(" "),
              _c("LayoutTwoSVG", {
                staticClass: "layout-icon layout-2",
                class: { disabledLayout: _vm.nrOfOpenTabs < 2 },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.setActiveLayout(2)
                  }
                }
              }),
              _vm._v(" "),
              _c("LayoutThreeSVG", {
                staticClass: "layout-icon layout-3",
                class: { disabledLayout: _vm.nrOfOpenTabs < 3 },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.setActiveLayout(3)
                  }
                }
              }),
              _vm._v(" "),
              _c("LayoutFourSVG", {
                staticClass: "layout-icon layout-4",
                class: { disabledLayout: _vm.nrOfOpenTabs < 4 },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.setActiveLayout(4)
                  }
                }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d2430dda", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d2430dda","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/NavBar/LayoutSelection.vue
// module id = null
// module chunks = 